import { AppState } from './app';
import * as constants from '../constants';
import { addToSSObject } from '../utils/react';

// We type the payload cast inside each switch case:
export type Journey1LegacyActionType = {
  type:
    | typeof constants.STEP1_SAVE
    | typeof constants.FETCHED_PROPOSALS
    | typeof constants.SET_CHOSEN_PROPOSAL
    | typeof constants.POSSIBLE_FORMATS
    | typeof constants.FETCHED_BUDGETS;

  payload: any;
};

export const journey1LegacyReducer = (state: AppState, action: Journey1LegacyActionType) => {
  switch (action.type) {
    case constants.STEP1_SAVE: {
      addToSSObject('userDataEC', 'details', action.payload.details);
      addToSSObject('userDataEC', 'audience', action.payload.audience);
      return {
        ...state,
        userDataEC: {
          ...state.userDataEC,
          audience: action.payload.audience,
          details: action.payload.details,
        },
      };
    }

    case constants.FETCHED_PROPOSALS: {
      const newProposals = {};
      action.payload.data.forEach((proposal, idx) => {
        newProposals[proposal.basket] = proposal;
      });
      addToSSObject('ecState', 'proposals', action.payload.data);
      addToSSObject('ecState', 'proposalsObj', newProposals);
      return {
        ...state,
        proposals: action.payload.data,
        proposalsObj: { ...newProposals },
        proposalsError: action.payload.notices,
      };
    }

    case constants.SET_CHOSEN_PROPOSAL: {
      return {
        ...state,
        userDataEC: {
          ...state.userDataEC,
          chosenProposal: action.payload,
        },
      };
    }

    case constants.POSSIBLE_FORMATS: {
      return {
        ...state,
        userDataEC: {
          ...state.userDataEC,
          possibleFormats: action.payload,
        },
      };
    }

    case constants.FETCHED_BUDGETS: {
      return {
        ...state,
        userDataEC: {
          ...state.userDataEC,
          budget: state.userDataEC.budget ? state.userDataEC.budget : action.payload.data.advised,
          minBudget: action.payload.data.minimum,
          advisedBudget: action.payload.data.advised,
        },
      };
    }
  }
};
